import React, { useEffect, useRef, useState } from 'react';
import styles from './TraderCard.module.css';
import Banner from './Banner';
import { useNavigate } from 'react-router-dom';
import AvatarFields from '../ui/AvatarFields/AvatarFields';
import { upload, erase } from '../../api/handleTraderUploads';
import { getTrader, putTrader } from '../../api/Trader/trader';
import getCoordinates from '../utils/getCoodinates';
import Logo from './Logo';

const TraderCard = () => {
    const [company, setCompany] = useState('');
    const [number, setNumber] = useState('');
    const [address, setAddress] = useState('');
    const [description, setDescription] = useState('');
    const [bannerUrl, setBannerUrl] = useState('');
    const [logoUrl, setLogoUrl] = useState('');
    const [instaUrl, setInstaUrl] = useState('');
    const [tiktokUrl, setTiktokUrl] = useState('');
    const [facebookUrl, setFacebookUrl] = useState('');
    const [website, setWebsite] = useState('');
    const [error, setError] = useState(null);
    const paraRef = useRef(null);
    const [bannerFile, setBannerFile] = useState(undefined);
    const [logoFile, setLogoFile] = useState(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfil = async () => {
            const result = await getTrader(navigate);
        
            if (!result.success)
                return;
            
            const data = result.data;

            if (data) {
                setCompany(data.company ?? '');
                setNumber(data.number ?? '');
                setAddress(data.address ?? '');
                setDescription(data.description ?? '');
                setWebsite(data.website ?? '');
                setInstaUrl(data.instaUrl ?? '');
                setTiktokUrl(data.tiktokUrl ?? '');
                setFacebookUrl(data.facebookUrl ?? '');
                setLogoUrl(`${process.env.REACT_APP_BACKEND_URL}/uploads/logoTrader${data.id}.jpeg`);
                setBannerUrl(`${process.env.REACT_APP_BACKEND_URL}/uploads/bannerTrader${data.id}.jpeg`);
            }
        };
        fetchProfil();
    }, [navigate]);

    async function handleForm(e) {
        e.preventDefault();

        const coords = await getCoordinates(address);
        const result = await putTrader({
            company: company.trim(),
            number: number.trim(),
            address: address.trim(),
            description: description?.trim() || null,
            instaUrl: instaUrl?.trim() || null,
            tiktokUrl: tiktokUrl?.trim() || null,
            facebookUrl: facebookUrl?.trim() || null,
            website: website?.trim() || null,
            location: coords,
            navigate,
        });
        console.log("Return value of putTrader: ", result);

        if (result.success) {
            if (paraRef.current) paraRef.current.style.color = "green";
            setError(result.message);
        } else {
            if (paraRef.current) paraRef.current.style.color = "red";
            setError(result.error.message);
        }
        if (bannerFile === null) {
            await erase({ index: 'banner' });
            setBannerUrl(null);
        } else {
            await upload({ index: 'banner', file: bannerFile });
        }

        if (logoFile !== undefined) {
            if (logoFile === null) {
                await erase({ index: 'logo' });
                setLogoUrl(null);
            } else {
                await upload({ index: 'logo', file: logoFile });
            }
        }
    }

    return (
        <form onSubmit={handleForm} className={styles.layout}>
            <Banner
                bannerUrl={bannerUrl}
                setBannerUrl={setBannerUrl}
                setBannerFile={setBannerFile}
            />
            <Logo
                logoUrl={logoUrl}
                setLogoUrl={setLogoUrl}
                setLogoFile={setLogoFile}
                company={company}
                setCompany={setCompany}
            />

            <div className={styles.about}>
                <h1 className={styles.subtitle}>À propos</h1>
                <div className={styles.fieldBox}>
                    <AvatarFields index='address' value={address} setValue={setAddress} />
                    <AvatarFields index='phone' value={number} setValue={setNumber} />
                    <AvatarFields index='link' value={website} setValue={setWebsite} />
                    <AvatarFields index='insta' value={instaUrl} setValue={setInstaUrl} />
                    <AvatarFields index='tiktok' value={tiktokUrl} setValue={setTiktokUrl} />
                    <AvatarFields index='facebook' value={facebookUrl} setValue={setFacebookUrl} />
                </div>
            </div>

            <div className={styles.descriptionBox}>
                <h1 className={styles.subtitle}>Description</h1>
                <textarea
                    className={styles.description}
                    placeholder="Décris ton offre ici..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>

            <div className={styles.btnBox}>
                <p ref={paraRef} className={styles.error}>{error}</p>
                <button className={styles.btn} type="submit">Mettre à jour</button>
            </div>
        </form>
    );
};

export default TraderCard;
